module.exports = __webpack_public_path__ + "static/media/s3.2c1535f0.jpg";